import $ from "jquery";
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import { SUPER_ADMIN_CODE, USER_CODE } from "./../../ConstRole/ConstRole";
import Container from './../../../../utilities/Container';
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";
const cards = { border: '1px solid #666', display: 'block', paddingInline: "10px", paddingBlock: "5px", cursor: "move" };

const SortVoucherBrandBasedOnCategory = (props) => {
    

    const navigate = useNavigate();
    const { state } = useLocation();
    const userProfile = useContext(UserBasicInfoContext);

    const [voucherBrandList, setVoucherBrand] = useState([]);


    // Company List
    useEffect(() => {
        if ((state?.data === null || state?.data === undefined || state?.data === "")) {
            return navigate(-1);
        }

        getBrandList();

    }, [state]);


    const getBrandList = async () => {
        await PostLoginGetApi("voucher/brand/based-on-category/" + state.data?.id, '', 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setVoucherBrand(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    const updateSortOrder = async () => {
        let brand_arr = [];

        $(".brand_id").each((i)=>{
            brand_arr[i] = $(".brand_id").eq(i).val();
        });

        // Now call API to save the updated sorted lists
        await PostLoginPostApi("voucher/brand/based-on-category/position-update", JSON.stringify({"brand_id": brand_arr}), 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success(responseData["messages"].toString());
                    return;
                }

                toast.error(responseData["message"].toString() ?? responseData["messages"].toString() ?? "A problem occur. Please try again." );
            }

        }).catch((err) => {
            console.log(err);
        })
    }


    if (userProfile?.user_type_id !== SUPER_ADMIN_CODE && userProfile?.user_type_id !== USER_CODE) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="custom-container w-full font-montserrat flex px-3">

            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-0 pt-3 static">
                    <div className="w-2/3 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-3">Here’s your sorted voucher brands for <strong>Category ({state.data?.name})</strong> based on display position</h6>
                    </div>
                    
                    <div className="w-1/3 h-[40px] pt-2 float-left text-right justify-end flex items-center">
                        <button type="button" onClick={updateSortOrder} className="text-md border-[#00D632] border-2 rounded hover:bg-[#00D632] hover:text-white hidden" style={{padding: "9px 20px", display: "inline-block"}} >Save Sorted Order</button>
                    </div>
                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-6">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>

                            {(voucherBrandList.length) > 0 && 
                                <Container id="container">
                                    {voucherBrandList.map((data, key) => (
                                        <div draggable="true" style={cards} key={key} className="hover:bg-gray-100">
                                            <input type="hidden" className="brand_id" name="brand_id[]" value={data.id} />
                                            <input type="hidden" className="brand_name" name="brand_name[]" value={data.name} />
                                            <span className='w-10 pl-2 h-full block float-left'>
                                                <strong className="text-sm">{data.position}</strong>
                                            </span>
                                            <span>
                                                <span className='w-[750px] block float-left'>
                                                    {data.name}
                                                </span>
                                                
                                                <span className='w-[300px] block float-left'>
                                                    {data.category_name ?? ""}
                                                </span>
                                                
                                                <Link to={`/dashboard/company-details/${data.company?.id}`} className="text-[#0774E9] " target="_blank" >
                                                    {data.company?.name}
                                                </Link>
                                                
                                                <span className='w-[100px] block float-left'>
                                                    {(data.is_featured === 1) ? "F" : <>-</> }
                                                </span>

                                                &nbsp;

                                            </span>
                                        </div>
                                    ))}
                                </Container>
                            }

                            
                        </div>
                    </div>
                </div>


            </div>

            
        </div>
    );
};

export default SortVoucherBrandBasedOnCategory;